import React, { useContext, useEffect, useState } from "react";
import { IoMdOpen, IoMdSettings } from "react-icons/io";
import BasicModal from "../Modals/BasicModal";
import PafServiceScoreGraph from "./psfServiceGraph/PafServiceScoreGraph";
import PsfServiceCustomerEffortGraph from "./psfServiceGraph/PsfServiceCustomerEffortGraph";
import PsfServiceDssatGraph from "./psfServiceGraph/psfServiceDssatGraph";
import { fetchPsfServiceData } from "./psfSalesServiceKpi";
import { FilterContext } from "../../context/Filter";

const PsfServiceCard = () => {
  const [psfServiceModal, setPsfServiceModal] = useState(false);
  const [customerEffortModal, setCustomerEffortModal] = useState(false);
  const [dissatisfactionModal, setDissatisfactionModal] = useState(false);
  const { arn: parArn, childArn } = useContext(FilterContext);
  const [psfServiceData, setPsfServiceData] = useState(null);
    const [loading, setLoading] = useState(true);
  
    const fetchPsfService = async () => {
        setLoading(true);
        try {
          const response = await fetchPsfServiceData(parArn, childArn);
         setPsfServiceData(response);
        } catch (error) {
          console.error("Error fetching all years data:", error);
          setPsfServiceData(0);
        } finally {
          setLoading(false);
        }
      };
  
      useEffect(() => {
        fetchPsfService();
      },[])
      // console.log("psfServiceData", psfServiceData)
  return (
    <div className="rounded-md w-[350px] h-[160px] border p-2 flex flex-col gap-4">
      {/* Header */}
      <div className="flex gap-2 items-center">
        <div className="p-2 bg-green-500 rounded-md text-white font-semibold w-8">
          <IoMdSettings />
        </div>
        <p className="text-md font-semibold">PSF Service {`(${psfServiceData?.key})`}</p>
      </div>

      {/* Metrics Section */}
      <div className="flex items-center justify-center gap-4">
        {/* PSF Service */}
        <div className="flex flex-col justify-center items-center gap-2">
          <p className="text-sm text-gray-500">PSF Service</p>
          <p className="font-semibold">{psfServiceData?.psf_ || 0}%</p>
          <BasicModal
            open={psfServiceModal}
            handleOpenModal={() => setPsfServiceModal(true)}
            handleCloseModal={() => setPsfServiceModal(false)}
            title="PSF Service"
            trigger={
              <div
                className="w-8 text-white p-2 rounded-md bg-blue-500 cursor-pointer"
                onClick={() => setPsfServiceModal(true)}
              >
                <IoMdOpen />
              </div>
            }
          >
           <PafServiceScoreGraph />
          </BasicModal>
        </div>

        {/* Customer Effort */}
        <div className="flex flex-col justify-center items-center gap-2">
          <p className="text-sm text-gray-500">Customer Effort</p>
          <p className="font-semibold">{psfServiceData?.ces_ || 0}%</p>
          <BasicModal
            open={customerEffortModal}
            handleOpenModal={() => setCustomerEffortModal(true)}
            handleCloseModal={() => setCustomerEffortModal(false)}
            title="Customer Effort"
            trigger={
              <div
                className="w-8 text-white p-2 rounded-md bg-blue-500 cursor-pointer"
                onClick={() => setCustomerEffortModal(true)}
              >
                <IoMdOpen />
              </div>
            }
          >
           <PsfServiceCustomerEffortGraph />
          </BasicModal>
        </div>

        {/* Dissatisfaction */}
        <div className="flex flex-col justify-center items-center gap-2">
          <p className="text-sm text-gray-500">Dissatisfaction</p>
          <p className="font-semibold">{psfServiceData?.dssat_ || 0}%</p>
          <BasicModal
            open={dissatisfactionModal}
            handleOpenModal={() => setDissatisfactionModal(true)}
            handleCloseModal={() => setDissatisfactionModal(false)}
            title="Dissatisfaction"
            trigger={
              <div
                className="w-8 text-white p-2 rounded-md bg-blue-500 cursor-pointer"
                onClick={() => setDissatisfactionModal(true)}
              >
                <IoMdOpen />
              </div>
            }
          >
           <PsfServiceDssatGraph/>
          </BasicModal>
        </div>
      </div>
    </div>
  );
};

export default PsfServiceCard;
